module.exports = __webpack_public_path__ + "static/media/angle-right.d2ee292a.svg";